import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef } from '@angular/material/dialog';
import { FileUploader } from 'ng2-file-upload';
import { read, utils } from 'xlsx';

import { AppService } from '../../_services/app.service';
import { TWADialogsService } from '../../_services/twa-dialogs.service';
import { ServerConn } from '../../_services/serverConn.service';

@Component({
    selector: 'app-dialog-upload',
    templateUrl: './dialog-upload.component.html',
    styleUrls: ['./dialog-upload.component.css'],
    standalone: false
})
export class DialogUploadComponent implements OnInit {

  public uploader: FileUploader;
  public uploading = false;
  public idcomunidad = 0;
  public comunidades: any[] = [];

  hasBaseDropZoneOver:boolean;
  hasAnotherDropZoneOver:boolean;

  constructor(
    private dialogRef: MatDialogRef<DialogUploadComponent>,
    private appSvc: AppService,
    private server: ServerConn,
    private snackBar: MatSnackBar,
    private dlgsSvc: TWADialogsService,
    private http: HttpClient,
  ) {
    this.uploader = new FileUploader({
      url: this.server.serverUrl + 'comunidades/' +
            this.idcomunidad + '/import?api_key=' + localStorage.getItem('api_key'),
      disableMultipart: false,
      itemAlias: 'files[]'
    });
    
    this.uploader.onAfterAddingFile = (fileItem) => {
      fileItem.withCredentials = false;
      const rawFile = fileItem._file;
      const extension = rawFile.name.split('.').pop().toLowerCase();
      
      // Archivos de texto o CSV
      if (['txt', 'csv'].includes(extension)) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          (fileItem as any).previewContent = e.target.result;
        };
        reader.readAsText(rawFile, 'ISO-8859-1');
      } 
      // Archivos Excel
      else if (['xls', 'xlsx'].includes(extension)) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const data = new Uint8Array(e.target.result);
          const workbook = read(data, { type: 'array' });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          // Convertir la primera hoja a formato CSV (o HTML) para previsualizar
          (fileItem as any).previewContent = utils.sheet_to_csv(worksheet);
        };
        reader.readAsArrayBuffer(rawFile);
      }
    };
  }

  ngOnInit() {
    this.comunidades = this.appSvc.comunidades;
  }

  setComm(ev) {
    this.idcomunidad = ev.value;
  }

  upload() {
    // Crear FormData con todos los archivos
    const formData = new FormData();
    
    this.uploader.queue.forEach(item => {
      formData.append('files[]', item._file, item._file.name);
    });

    const url = 'comunidades/' + this.idcomunidad + '/import?api_key=' + localStorage.getItem('api_key');
    
    this.uploading = true;
    
    // Hacer una sola llamada HTTP con todos los archivos
    this.server.post(url, formData).subscribe({
      next: (response: any) => {
        this.uploading = false;
        
        var msg = "";
        Object.values(response.data).forEach((archivo: any, idx) => {
          msg += 'Se han importado ' + archivo.ctr + ' solicitudes y ' + archivo.ctd + ' crotales del archivo ' + (idx + "1") + '.\n\r';
          if (archivo.cte) {
            msg += ' ' + archivo.cte + ' solicitudes ya existían.\n\r';
          }
        });

        this.dialogRef.close();
        this.dlgsSvc.confirm('Importación finalizada', msg).subscribe((res: any) => {});
      },
      error: (error) => {
        this.uploading = false;
        console.error('Error al subir archivos:', error);
        this.snackBar.open(
          'Se ha producido un error al importar las solicitudes',
          'Cerrar',
          {
            duration: 10000
          });
      }
    });
  }

  public fileOverBase(e:any):void {
    this.hasBaseDropZoneOver = e;
  }

}
